import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 418.78 157.65"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M146.94 96.76s-37.7-17.23-36.98-26.66c.09-.94.55-1.83 1.47-2.58 0 0 19.64-21.64 57.73-36.89 30.73-12.33 38-11.48 38-11.48-.53 14.11 8.59 25.23 23.28 30.35 0 0 57.59-18.34 90.1-20.97 39.24-3.19 53.49 11.42 53.49 11.42s32.6 1.88 43.43 8.57c0 0 1.38 1.1 1.32 1.67-.02.19-.21.29-.66.29-1.81.03-7.79-1.28-16.53-.34-20.9 2.25-58.56 6.87-69.69 13.05 0 0-60.46 95.81-331.9 94.44 0 0 84.02-18.32 146.94-60.87",
      style: {"fill":"#25407b"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M212.46 2.95c2.41-.14 8.05.82 9.25 4.05 0 0-8.83-5.28-120.38 30.13C66.35 48.21 13.62 11.48.13 0c0 0 42.18 11.12 212.33 2.95",
      style: {"fill":"#d42b3f"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "RC-logo"}) } }